export default __webpack_public_path__ + "static/media/screenshot4.ec29e2c6.png";